import { Dialog, Slide } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

import { IColorTheme } from '~/config/shared/reseller-config';
import { track } from '~/src/dash/analytics/analytics';
import { IUser } from '~/src/dash/api/console-api';
import { LogoutIcon, ReturnIcon } from '~/src/dash/components/icons/misc-icons';
import { Col, Cols, Row, Rows, spacing, TextButton, usePanel } from '~/src/dash/publicaUI';
import { getDemoSSAIUsername } from '~/src/dash/resellers/utils/importResellerConfig';
import {
  IInventoryRoute,
  logout,
  navigate,
  RouteDashboards,
  RouteNetworkDashboard,
} from '~/src/dash/router/routes';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';
import { useMobileStore } from '~/src/dash/views/mobile/contexts';

const replaceSSAILandingRoute = (user: IUser, defaultRoute: IInventoryRoute): IInventoryRoute => {
  return getDemoSSAIUsername() === user.Username ? RouteNetworkDashboard : defaultRoute;
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='right' ref={ref} {...props} />;
});

interface INavModalProps {
  open: boolean;
  handleClose: () => void;
  theme: IColorTheme;
}

export const NavModal = ({ open, handleClose }: INavModalProps) => {
  const { user } = useMobileStore();
  const isSuperUser = hasRoleSuperUser(user.user);
  const { theme } = usePanel();
  return (
    <Dialog
      fullScreen
      open={open}
      // @ts-ignore
      TransitionComponent={Transition}
    >
      <Rows
        style={{
          height: '100%',
          overflow: 'hidden',
          backgroundColor: theme.menuBarBackground,
          color: theme.menuBarText,
        }}
      >
        <Row style={{ textAlign: 'right' }}>
          <CloseIcon onClick={handleClose} style={{ width: '18px' }} />
        </Row>
        <Row style={{ height: '100%', overflowY: 'auto', padding: '0px 16px 32px' }}>
          <Rows gap={spacing.medium}>
            {/* TODO: THIS SHOULD BE MADE DYNAMIC WHEN WE CREATE A FULL NAVIGATION */}
            <Row noVerticalPadding>
              <TextButton color={theme.menuBarText} onClick={logout}>
                <Cols style={{ alignItems: 'center' }}>
                  <Col displayFlex style={{ minWidth: '32px' }}>
                    <LogoutIcon color={theme.menuBarText} />
                  </Col>
                  <Col>Logout</Col>
                </Cols>
              </TextButton>
            </Row>
            <Row noVerticalPadding>
              <TextButton
                color={theme.menuBarText}
                onClick={() => {
                  sessionStorage.setItem('forceDesktop', 'true');
                  track('Mobile - Return To Desktop View', { isSuperUser }, user.user);
                  navigate(replaceSSAILandingRoute(user.user, RouteDashboards), {
                    p: user.publisher.ID,
                  });
                }}
              >
                <Cols style={{ alignItems: 'center' }}>
                  <Col displayFlex style={{ minWidth: '32px' }}>
                    <ReturnIcon color={theme.menuBarText} />
                  </Col>
                  <Col>Desktop View</Col>
                </Cols>
              </TextButton>
            </Row>
          </Rows>
        </Row>
      </Rows>
    </Dialog>
  );
};
